import sessionStore from './Session'

export default {
  sessionStore
}
